/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';
import {LoadingState, LoadingStateInterface} from '@/components/Loading/types';
import {
    UgcBuildErrorCodeInteface,
    UgcRevisionInterface,
} from '@/store/modules/ugc-build/types';
import {Action} from 'vuex-class';

const namespace: string = 'ugcBuildModule';

/**
 * Revision error details component.
 *
 * Component that provides a uniform loading component.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-revision-error',
})
export default class RevisionError extends Vue {
    @Prop(Object) public build!: UgcRevisionInterface;
    @Action('errors', {namespace}) public errors: any;

    public loading: LoadingStateInterface = new LoadingState();
    public error: UgcBuildErrorCodeInteface[] = [];
    public selectedIndex: number = -1;

    /**
     * Created lifecycle event.
     *
     * Note: loads the errors based on the currently loaded item.
     */
    public mounted(): void {
        this.loadErrors();
    }

    /**
     * Error checker.
     *
     * @returns {boolean}
     */
    public get hasErrors(): boolean {
        return !!this.error && 0 < this.error.length;
    }

    /**
     * Load errors for build.
     *
     * @returns {Promise<void>}
     */
    public async loadErrors(): Promise<void> {
        try {
            this.loading.start();
            this.error = await this.errors(this.build);
            this.loading.complete();
        } catch (err) {
            this.loading.failed();
        }
    }
}

